import React, { FC, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { PlusIcon } from '@shared/assets/icons';
import { withTheme } from '@shared/lib/theme';
import { Text } from '@shared/ui/atoms';
import { useModal } from '@shared/lib';
import { ModalProps } from '@shared/ui/organisms';
type SuggestModalProps = ModalProps;
interface SuggestButtonProps {
  renderSuggestModal: (props: SuggestModalProps) => ReactNode;
}
const SuggestButton: FC<SuggestButtonProps> = ({
  renderSuggestModal
}) => {
  const {
    isModalActive,
    handleModalOpen,
    handleModalClose
  } = useModal();
  return <>
      <SuggestButtonWrapper onClick={handleModalOpen}>
        <IconWrapper>
          <PlusIcon />
        </IconWrapper>
        <Text size="pS" color="accent">
          Предложить игру или сервис
        </Text>
      </SuggestButtonWrapper>
      {renderSuggestModal({
      open: isModalActive,
      onClose: handleModalClose
    })}
    </>;
};
export default SuggestButton;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.hover;
const SuggestButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "SuggestButtonWrapper",
  class: "srvt8fi",
  propsAsIs: false,
  vars: {
    "srvt8fi-0": [_exp()]
  }
}));
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.accent_30;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.accent;
const IconWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i941qrv",
  propsAsIs: false,
  vars: {
    "i941qrv-0": [_exp2()],
    "i941qrv-1": [_exp3()]
  }
}));

require("./SuggestButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SuggestButton.tsx");